import React from 'react';
import { twMerge } from 'tailwind-merge';

interface OrganizationProps {
  className?: string;
  width?: number;
  height?: number;
}

const OrganizationIcon = function OrganizationIcon({
  className,
  width,
  height,
}: OrganizationProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <circle className={twMerge(className, 'fill-white')} cx="11.8574" cy="3.71429" r="1.33929" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-white')} d="M11.8571 6.57031C14.0291 6.57031 14.55 8.55162 14.6749 9.50191C14.7109 9.7757 14.4904 9.99888 14.2143 9.99888H9.5C9.22386 9.99888 9.00342 9.7757 9.03941 9.50191C9.16432 8.55162 9.68519 6.57031 11.8571 6.57031Z" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <circle className={twMerge(className, 'fill-white')} cx="4.5" cy="16.5" r="1.125" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-white')} d="M4.5 19C6.35433 19 6.83324 20.6505 6.95693 21.503C6.99658 21.7763 6.77614 22 6.5 22H2.5C2.22386 22 2.00342 21.7763 2.04307 21.503C2.16676 20.6505 2.64567 19 4.5 19Z" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <circle className={twMerge(className, 'fill-white')} cx="12.5" cy="16.5" r="1.125" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-white')} d="M12.5 19C14.3543 19 14.8332 20.6505 14.9569 21.503C14.9966 21.7763 14.7761 22 14.5 22H10.5C10.2239 22 10.0034 21.7763 10.0431 21.503C10.1668 20.6505 10.6457 19 12.5 19Z" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <circle className={twMerge(className, 'fill-white')} cx="20.5" cy="16.5" r="1.125" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-white')} d="M20.5 19C22.3543 19 22.8332 20.6505 22.9569 21.503C22.9966 21.7763 22.7761 22 22.5 22H18.5C18.2239 22 18.0034 21.7763 18.0431 21.503C18.1668 20.6505 18.6457 19 20.5 19Z" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-white')} d="M4 14V13C4 12.4477 4.44772 12 5 12H20C20.5523 12 21 12.4477 21 13V14" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-white')} d="M12.5 12.5V14" stroke="#28364C" strokeWidth="0.75" strokeLinecap="round" />
    </svg>
  );
};

OrganizationIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default OrganizationIcon;
